import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FLAG = 'oc_driver_signed_in';
const LEGACY_TOKEN_KEY = 'oc_driver_token';

try { localStorage.removeItem(LEGACY_TOKEN_KEY); } catch { /* storage unavailable */ }

// Non-sensitive hint only; the real session is the httpOnly driver_token cookie.
export const isDriverSignedIn = () => {
  try { return localStorage.getItem(FLAG) === '1'; } catch { return false; }
};

export const markDriverSignedIn = (on) => {
  try {
    if (on) localStorage.setItem(FLAG, '1');
    else localStorage.removeItem(FLAG);
  } catch { /* storage unavailable */ }
};

export const driverApi = axios.create({ baseURL: API, withCredentials: true });

export const driverLogout = async () => {
  markDriverSignedIn(false);
  try {
    await driverApi.post('/driver/auth/logout');
  } catch (err) {
    console.warn('Driver logout request failed', err?.message);
  }
};

driverApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      markDriverSignedIn(false);
      const here = window.location.pathname;
      const safeNext = here.startsWith('/driver/login') ? '/driver' : here;
      if (!here.startsWith('/driver/login')) {
        window.location.assign(`/driver/login?next=${encodeURIComponent(safeNext)}`);
      }
    }
    return Promise.reject(err);
  }
);

export { API };
